<template>
  <div
    id="app"
    class="wrapper"
    :class="{ login: $route.path === '/login', light: !this.$store.getters.darkmode }"
  >
    <Header />

    <main>
      <transition class="fade" name="fade" mode="out-in">
        <router-view />
      </transition>
    </main>

    <ModalBtns />
    <MediaModal />
    <ModalProperties />
    <FacialCodingModal />
    <ModalPreview />
    <LoginModal />
    <CloneSurveyModal />
    <ModalTemplate />

    <SurveyAdvancedSettingsModal />
    <ModalGroupsAdvancedSettings />

    <PortalTarget :name="PORTAL_NAMES.MODAL_DEFAULT"></PortalTarget>

    <AppMessage :message="$store.getters.messages" />
  </div>
</template>

<script>
import Header from '@/components/Header.vue'

import AppMessage from '@/components/AppMessage.vue'

import ModalBtns from '@/components/ModalBtns.vue'
import LoginModal from '@/components/ModalLogin.vue'
import ModalProperties from '@/components/ModalProperties.vue'
import MediaModal from '@/pages/Scheme/MediaModal.vue'
import FacialCodingModal from '@/pages/FacialCoding/FacialCodingModal.vue'
import ModalPreview from '@/components/ModalPreview.vue'
import CloneSurveyModal from '@/components/ModalClone.vue'

import ModalGroupsAdvancedSettings from '@/components/ModalGroupsAdvancedSettings.vue'
import SurveyAdvancedSettingsModal from '@/pages/Scheme/SurveyAdvancedSettings'

import ModalTemplate from '@/pages/Templates/ModalTemplate.vue'

import { PORTAL_NAMES } from '@/utils/constants'

export default {
  name: 'App',

  components: {
    Header,
    AppMessage,
    ModalBtns,
    MediaModal,
    FacialCodingModal,
    ModalProperties,
    ModalPreview,
    LoginModal,
    CloneSurveyModal,
    ModalTemplate,
    ModalGroupsAdvancedSettings,
    SurveyAdvancedSettingsModal,
  },

  data() {
    return {
      PORTAL_NAMES,
    }
  },
}
</script>

<style lang="scss">
body {
  margin: 0;
  padding: 0;
}
div#app {
  background-size: cover;
  min-height: 100vh;
  position: relative;
}

div#app.wrapper {
  background: $main-two;
  transition: all 1s ease-in-out;
  &.light {
    background: $white-2;
  }
}

main {
  position: relative;
  padding: 0 20px 40px;
}

.black {
  color: $main !important;
}
div#app.login {
  background: $main-two;
  &.light {
    background: $white-2;
  }
}

.fade {
  transition: 0.8s all cubic-bezier(0.075, 0.82, 0.165, 1);
}

.fade-enter-to {
  opacity: 1;
  transform: translate3d(0, 0px, 0);
}
.fade-leave-to {
  opacity: 0;
  transform: translate3d(0, 20px, 0);
}
.fade-enter {
  opacity: 0;
  transform: translate3d(-20px, 0, 0);
}
.fade-leave {
  opacity: 1;
  transform: translate3d(0, 0, 0);
}

.data-table {
  .el-table {
    @include tipography(16);
    th,
    tr,
    td {
      transition: all 1s ease-in-out;
      background-color: $gray-7 !important;
      @include tipography(16);
      &:hover {
        background-color: $gray-7 !important;
      }
    }
  }
  &.light {
    .el-table {
      th,
      tr,
      td {
        transition: all 1s ease-in-out;
        background-color: $white !important;
        color: $gray-6;
        &:hover {
          background-color: $white !important;
        }
      }
    }
  }
}

.el-row {
  display: flex;
  justify-content: flex-end;
  .searchDatatable {
    display: flex;
    justify-content: flex-end;
    position: relative;
    margin-top: 20px;
    img {
      width: 20px;
      position: absolute;
      right: 10px;
      top: 10px;
    }
  }
  .el-input {
    flex: 1;
    max-width: 350px;
    @include d(s) {
      width: 300px;
      margin-bottom: 20px;
      margin-right: 0;
    }
    input {
      @include tipography(16);
      width: 100%;
      color: $gray-5;
      background: none;
      border: 1px solid $gray-5;
      padding: 8px 10px;
      border-radius: 3px;
    }
    ::placeholder {
      color: $white;
      opacity: 1;
    }

    ::-webkit-input-placeholder {
      color: $white;
    }

    :-moz-placeholder {
      color: $white;
    }

    ::-moz-placeholder {
      color: $white;
    }

    :-ms-input-placeholder {
      color: $white;
    }
    &.light {
      input {
        color: $gray-6;
      }
      ::placeholder {
        color: $gray-6;
        opacity: 1;
      }
      ::-webkit-input-placeholder {
        color: $gray-6;
      }

      :-moz-placeholder {
        color: $gray-6;
      }

      ::-moz-placeholder {
        color: $gray-6;
      }

      :-ms-input-placeholder {
        color: $gray-6;
      }
    }
  }
}

.el-row .el-input input {
  padding-right: 32px;
}

.data-table {
  .pagination-bar {
    @include tipography(16);
    margin-top: 20px;
    .el-pagination__jump,
    .el-pagination__total {
      color: $white;
    }
  }
  &.light {
    .el-pagination__jump,
    .el-pagination__total {
      color: $gray-6;
    }
  }
}

.el-table {
  &::before {
    z-index: unset !important;
  }
}

.el-select-dropdown__item {
  @include tipography(12);
  color: $gray-6;
}

.el-pagination {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  ul,
  button,
  span {
    margin-bottom: 10px;
  }
}

.el-table__body-wrapper {
  overflow: unset !important;
}

.el-table__header-wrapper {
  overflow: unset !important;
}

.el-table {
  overflow: unset !important;
}

.el-button--text:focus,
.el-button--text:hover {
  color: unset !important;
}

.el-select-dropdown {
  position: absolute;
  // z-index: 99999 !important;
}

@media (max-width: 749px) {
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    margin: 5px 5px !important;
  }
}
</style>
<style src="./styles/override_styles.css"></style>
